import Grid from './grid';
import GridContainer from './grid-container';
Grid.Container = GridContainer;
export default Grid;